/**
 * Cart drawer Rebuy widget (301272):
 * Keep the original Add button.
 * Inject a "Select size" control with arrow that toggles variant swatches.
 * Scoped only to #rebuy-widget-301272.
 */
(function () {
  if (window.__rebuyCartQuickAddBound) return;
  window.__rebuyCartQuickAddBound = true;

  var WIDGET_ID = '301272';
  var WIDGET_SELECTOR = '#rebuy-widget-' + WIDGET_ID;
  var BIND_ATTR = 'data-rebuy-quick-add-bound';
  var BLOCK_CLASS = 'rebuy-quick-add';
  var OPEN_CLASS = 'rebuy-quick-add--open';
  var TOGGLE_CLASS = 'rebuy-quick-add-toggle';
  var observeTimer = null;

  function getWidgetRoot() {
    return document.querySelector(WIDGET_SELECTOR);
  }

  function isTargetWidget(widget) {
    if (!widget) return false;
    return String(widget.id) === WIDGET_ID;
  }

  function closeAllBlocks() {
    var root = getWidgetRoot();
    if (!root) return;

    root.querySelectorAll('.rebuy-product-block').forEach(function (block) {
      block.classList.remove(OPEN_CLASS);
      var toggle = block.querySelector('.' + TOGGLE_CLASS);
      if (toggle) setToggleState(toggle, false);
    });
  }

  function closeOtherBlocks(exceptBlock) {
    var root = getWidgetRoot();
    if (!root) return;

    root.querySelectorAll('.' + OPEN_CLASS).forEach(function (block) {
      if (block !== exceptBlock) {
        block.classList.remove(OPEN_CLASS);
        var otherToggle = block.querySelector('.' + TOGGLE_CLASS);
        if (otherToggle) setToggleState(otherToggle, false);
      }
    });
  }

  function setToggleState(toggle, isOpen) {
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    toggle.setAttribute('aria-label', isOpen ? 'Hide size options' : 'Show size options');
    toggle.classList.toggle('rebuy-quick-add-toggle--open', isOpen);
  }

  function onToggleClick(event) {
    event.preventDefault();
    event.stopPropagation();

    var toggle = event.currentTarget;
    var block = toggle.closest('.rebuy-product-block');
    if (!block) return;

    var willOpen = !block.classList.contains(OPEN_CLASS);

    if (willOpen) {
      closeOtherBlocks(block);
      block.classList.add(OPEN_CLASS);
    } else {
      block.classList.remove(OPEN_CLASS);
    }

    setToggleState(toggle, willOpen);

    // Clear sticky :hover/:focus styles on touch devices after tap
    if (typeof toggle.blur === 'function') toggle.blur();
  }

  function createToggleButton() {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = TOGGLE_CLASS;
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Show size options');
    button.innerHTML =
      '<span class="rebuy-quick-add-toggle__label">Select size</span>' +
      '<span class="rebuy-quick-add-toggle__arrow" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 10 6" fill="none" focusable="false">' +
      '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span>';
    button.addEventListener('click', onToggleClick);
    return button;
  }

  function ensureToggleMarkup(toggle) {
    if (
      toggle.querySelector('.rebuy-quick-add-toggle__label') &&
      toggle.querySelector('.rebuy-quick-add-toggle__arrow') &&
      toggle.querySelector('.rebuy-quick-add-toggle__label').nextElementSibling &&
      toggle.querySelector('.rebuy-quick-add-toggle__label').nextElementSibling.classList.contains('rebuy-quick-add-toggle__arrow')
    ) {
      return;
    }
    toggle.innerHTML =
      '<span class="rebuy-quick-add-toggle__label">Select size</span>' +
      '<span class="rebuy-quick-add-toggle__arrow" aria-hidden="true">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 10 6" fill="none" focusable="false">' +
      '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span>';
  }

  function placeToggle(block, toggle, options) {
    var price = block.querySelector('.rebuy-product-price');
    var info = block.querySelector('.rebuy-product-info');
    var actions = block.querySelector('.rebuy-product-actions');

    // Prefer: below price, inside product info (avoids Rebuy flex/order quirks)
    if (price && price.parentNode) {
      if (toggle.previousElementSibling !== price) {
        price.parentNode.insertBefore(toggle, price.nextSibling);
      }
      return;
    }

    if (info && actions && actions.parentNode === info) {
      if (toggle.nextElementSibling !== actions) {
        info.insertBefore(toggle, actions);
      }
      return;
    }

    if (toggle.nextElementSibling !== options) {
      options.parentNode.insertBefore(toggle, options);
    }
  }

  function enhanceProductBlock(block) {
    if (!block) return;

    var options = block.querySelector('.rebuy-product-options');
    if (!options || !options.querySelector('.rebuy-product-options__button-swatch')) {
      return;
    }

    var toggle = block.querySelector('.' + TOGGLE_CLASS);
    var isNewToggle = false;

    if (!toggle) {
      toggle = createToggleButton();
      isNewToggle = true;
    } else {
      ensureToggleMarkup(toggle);
      if (!toggle.getAttribute('data-listener-bound')) {
        toggle.addEventListener('click', onToggleClick);
      }
    }

    placeToggle(block, toggle, options);

    toggle.setAttribute('data-listener-bound', 'true');
    block.setAttribute(BIND_ATTR, 'true');
    block.classList.add(BLOCK_CLASS);

    // Always start closed unless this block was already intentionally opened
    // and still has the open class. New / re-rendered blocks stay closed.
    if (isNewToggle || !block.classList.contains(OPEN_CLASS)) {
      block.classList.remove(OPEN_CLASS);
      setToggleState(toggle, false);
    } else {
      setToggleState(toggle, true);
    }
  }

  function enhanceWidget() {
    var root = getWidgetRoot();
    if (!root) return false;

    root.querySelectorAll('.rebuy-product-block').forEach(enhanceProductBlock);
    return true;
  }

  function scheduleEnhance() {
    if (observeTimer) clearTimeout(observeTimer);
    observeTimer = setTimeout(function () {
      observeTimer = null;
      enhanceWidget();
    }, 50);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (!mutation.addedNodes || !mutation.addedNodes.length) continue;

      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue;

        if (
          (node.matches && node.matches(WIDGET_SELECTOR)) ||
          (node.querySelector && node.querySelector(WIDGET_SELECTOR)) ||
          (node.closest && node.closest(WIDGET_SELECTOR)) ||
          (node.matches && node.matches('.rebuy-product-block') && node.closest(WIDGET_SELECTOR)) ||
          (node.matches && node.matches('.rebuy-product-options') && node.closest(WIDGET_SELECTOR))
        ) {
          scheduleEnhance();
          return;
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('rebuy.ready', function (event) {
    if (isTargetWidget(event.detail && event.detail.widget)) scheduleEnhance();
  });

  document.addEventListener('rebuy.productsChange', function (event) {
    if (isTargetWidget(event.detail && event.detail.widget)) scheduleEnhance();
  });

  document.addEventListener('rebuy.refresh', function (event) {
    if (isTargetWidget(event.detail && event.detail.widget)) scheduleEnhance();
  });

  // Close size panels immediately on add so they never flash open during widget refresh
  document.addEventListener('rebuy.add', function (event) {
    var widget = event.detail && event.detail.widget;
    if (widget && !isTargetWidget(widget)) return;
    closeAllBlocks();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleEnhance);
  } else {
    scheduleEnhance();
  }
})();